var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "col-md-12 row no-padding no-margin subheader" },
      [
        _vm.subtitle
          ? [
              _c("span", { staticClass: "col-md-6 no-padding" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "col-md-6 no-padding subtitle" }, [
                _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      ")
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.subtitle
          ? [
              _c("span", { staticClass: "col no-padding" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            ]
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c("hr", { staticStyle: { margin: "5px 0 12px 0" } })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ceca1a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ceca1a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/SectionHeader.vue
// module id = null
// module chunks = 